import { useEffect, useMemo, useState } from 'react';
import { MILESTONES } from '@/mocks/schedule';
import { formatCnDate, pad2, toLocalDate } from '@/utils/date';

interface Remain {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

function diff(target: Date): Remain {
  const ms = Math.max(0, target.getTime() - Date.now());
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor((ms % 86400000) / 3600000),
    minutes: Math.floor((ms % 3600000) / 60000),
    seconds: Math.floor((ms % 60000) / 1000),
  };
}

export default function Countdown({ tone = 'dark' }: { tone?: 'dark' | 'light' }) {
  const next = useMemo(() => {
    const now = Date.now();
    const future = MILESTONES.filter((m) => toLocalDate(m.date).getTime() >= now);
    return future[0] ?? MILESTONES[MILESTONES.length - 1];
  }, []);

  const [remain, setRemain] = useState<Remain>(() => diff(toLocalDate(next.date)));

  useEffect(() => {
    const timer = window.setInterval(() => {
      setRemain(diff(toLocalDate(next.date)));
    }, 1000);
    return () => window.clearInterval(timer);
  }, [next]);

  const units = [
    { label: '天', value: remain.days },
    { label: '时', value: remain.hours },
    { label: '分', value: remain.minutes },
    { label: '秒', value: remain.seconds },
  ];

  const boxClass =
    tone === 'dark'
      ? 'bg-background-50/10 border border-background-50/20 text-background-50'
      : 'bg-background-100 border border-background-200 text-foreground-950';

  return (
    <div>
      <p
        className={`text-xs md:text-sm mb-3 ${
          tone === 'dark' ? 'text-background-200' : 'text-foreground-600'
        }`}
      >
        距离下一关键节点 <span className="font-medium">{next.title}</span>（{formatCnDate(next.date)}）还有
      </p>
      <div className="flex items-center gap-2 md:gap-3">
        {units.map((u) => (
          <div
            key={u.label}
            className={`w-16 md:w-20 py-3 rounded-md text-center ${boxClass}`}
          >
            <div className="font-heading text-xl md:text-2xl font-bold tabular-nums">
              {u.label === '天' ? u.value : pad2(u.value)}
            </div>
            <div className={`text-[11px] mt-1 ${tone === 'dark' ? 'text-background-300' : 'text-foreground-500'}`}>
              {u.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}